import React from "react";
import { StyledTable, Container } from "./RewardsDataHelpers";
import moment from "moment-mini";
import IGuestPointActivities from "../../../@types/IGuestProfile";
import { IRewardsDataProps } from "./RewardsDataProps";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";

const RewardsDetailMobile = ({
  items,
  loading,
}: {
  items: Array<IGuestPointActivities>;
  loading: boolean;
}) => {
  let keyCnt = 0;
  const content = !loading ? (
    items.map((item) => {
      const description = item?.description;
      const operation = item?.operation;
      const rewardPoints = item?.rewardPoints;
      const rewardDate = item?.transactionDate;
      return (
        <Container key={`reward-${keyCnt++}`}>
          <div className="points-date">
            {moment(rewardDate).format("MMM D, YYYY")}
          </div>
          <div className="points-title">{description}</div>
          <div className={`points-count ${operation}`}>
            {operation === "Deduct"}
            {rewardPoints ? rewardPoints.toLocaleString() : ""}{" "}
            <span>points</span>
          </div>
        </Container>
      );
    })
  ) : (
    <Container>
      <div className="points-date">
        <Skeleton width={100} />
      </div>
      <div className="points-title">
        <Skeleton width={150} />
      </div>
      <div className="points-count">
        <Skeleton width={50} />
      </div>
    </Container>
  );
  return <>{content}</>;
};

const RewardsDetail: React.FC<IRewardsDataProps> = ({ data, loading }) => {
  const { isMobileOnly } = useMobileDetectContext();
  const rewards = data;
  const rewardRows =
    rewards &&
    rewards.map((reward, index) => {
      const description = reward.description;
      const operation = reward.operation;
      const rewardPoints = reward.rewardPoints;
      const rewardDate = reward.transactionDate;
      const entryDate = moment(rewardDate).format("MMM D, YYYY"); //parseDate(reward.EntryDate, 'm-d-yyyy');
      return (
        <tr key={`reward-${index++}`}>
          <td>{entryDate}</td>
          <td>{description}</td>
          <td className={`points-${operation}`}>
            {operation === "Deduct"}
            {rewardPoints ? rewardPoints.toLocaleString() : ""}
          </td>
        </tr>
      );
    });
  const rewardsAvailable = rewardRows && rewardRows.length > 0;

  if (isMobileOnly && rewardsAvailable) {
    return <RewardsDetailMobile items={data} loading={loading} />;
  }

  return (
    <>
      {loading ? (
        <StyledTable>
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Points</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <Skeleton />
              </td>
              <td>
                <Skeleton />
              </td>
              <td>
                <Skeleton />
              </td>
            </tr>
          </tbody>
        </StyledTable>
      ) : rewardsAvailable ? (
        <StyledTable>
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Points</th>
            </tr>
          </thead>
          <tbody>{rewardRows}</tbody>
        </StyledTable>
      ) : null}
    </>
  );
};
export default RewardsDetail;
